const textProps = {
  image: require("assets/img/illustrations/500.svg").default,
  color: "indigo",
  error: "500",
  title: "Error :(",
  description: "We are sorry. This was unexpected.",
};
export default textProps;
